import type { GameModePreference } from 'generated/openapi';
import { type ReactNode } from 'react';
import { z } from 'zod';

import FaceExhaling from '@/assets/icons/face-exhaling.svg?react';
import FaceWithSteamFromNose from '@/assets/icons/face-with-steam-from-nose.svg?react';
import RelievedFace from '@/assets/icons/relieved-face.svg?react';
import SmilingFaceWithSunglasses from '@/assets/icons/smiling-face-with-sunglasses.svg?react';
import WinkingFaceWithTongue from '@/assets/icons/winking-face-with-tongue.svg?react';

const gameModePreferencesEnum = z.enum<GameModePreference[]>([
  'RANKED_ONLY',
  'MOSTLY_RANKED',
  'BALANCED',
  'MOSTLY_CASUAL',
  'CASUAL_ONLY',
]);

export interface GameModePreferenceOption {
  id: GameModePreference;
  icon: ReactNode;
  label: string;
}

export const GAME_MODE_PREFERENCE_MAP = new Map<
  GameModePreference,
  GameModePreferenceOption
>([
  [
    'RANKED_ONLY',
    {
      id: 'RANKED_ONLY',
      icon: <FaceWithSteamFromNose />,
      label: 'Only ranked',
    },
  ],
  [
    'MOSTLY_RANKED',
    {
      id: 'MOSTLY_RANKED',
      icon: <FaceExhaling />,
      label: 'Mostly ranked',
    },
  ],
  [
    'BALANCED',
    {
      id: 'BALANCED',
      icon: <SmilingFaceWithSunglasses />,
      label: "Don't care",
    },
  ],
  [
    'MOSTLY_CASUAL',
    {
      id: 'MOSTLY_CASUAL',
      icon: <RelievedFace />,
      label: 'Mostly casual',
    },
  ],
  [
    'CASUAL_ONLY',
    {
      id: 'CASUAL_ONLY',
      icon: <WinkingFaceWithTongue />,
      label: 'Only casual',
    },
  ],
]);

export const GAME_MODE_PREFERENCE_OPTIONS: GameModePreferenceOption[] =
  Array.from(GAME_MODE_PREFERENCE_MAP.values());

export const GAME_MODE_PREFERENCE_LABELS: Record<GameModePreference, string> = {
  RANKED_ONLY: 'Only ranked',
  MOSTLY_RANKED: 'Mostly ranked',
  BALANCED: "Don't care",
  MOSTLY_CASUAL: 'Mostly casual',
  CASUAL_ONLY: 'Only casual',
};

export const gameModePreferenceSchema = gameModePreferencesEnum;
